import fs from 'fs';
import path from 'path';
import { User, ClassRoom, Student, ScheduleSession, AttendanceRecord, ZaloNotificationLog, TuitionInvoice, InvoiceStats, SystemSettings, PaymentOrder, PricingPlan } from '../src/types';

interface DBData {
  users: User[];
  classes: ClassRoom[];
  students: Student[];
  sessions: ScheduleSession[];
  attendance: AttendanceRecord[];
  zaloLogs: ZaloNotificationLog[];
  invoices: TuitionInvoice[];
  paymentOrders?: PaymentOrder[];
  systemSettings?: SystemSettings;
}

const DB_FILE = path.join(process.cwd(), 'data_storage.json');

const DEFAULT_PRICING_PLANS: PricingPlan[] = [
  {
    id: 'plan_1m',
    name: 'Gói 1 Tháng',
    durationMonths: 1,
    price: 38000,
    originalPrice: 50000,
    popular: false,
    features: [
      'Quản lý không giới hạn lớp học & học sinh',
      'Thời khóa biểu đa ca, đổi lịch dời ca linh hoạt',
      'Hóa đơn học phí VietQR tự động',
      'Điểm danh và đồng bộ Google Sheet riêng biệt'
    ]
  },
  {
    id: 'plan_6m',
    name: 'Gói 6 Tháng',
    durationMonths: 6,
    price: 420000,
    originalPrice: 500000,
    popular: false,
    features: [
      'Đầy đủ mọi tính năng gói 1 Tháng',
      'Hạn sử dụng 6 tháng liên tục',
      'Hỗ trợ kỹ thuật ưu tiên 24/7',
      'Sao lưu dữ liệu tự động định kỳ'
    ]
  },
  {
    id: 'plan_12m',
    name: 'Gói 12 Tháng (Tiết Kiệm Nhất)',
    durationMonths: 12,
    price: 350000,
    originalPrice: 600000,
    popular: true,
    features: [
      'Toàn bộ tính năng cao cấp nhất',
      'Sử dụng trọn vẹn 1 năm học (12 tháng)',
      'Tặng kèm tính năng gửi tin nhắn Zalo tự động',
      'Kích hoạt ngay lập tức qua QR SePay'
    ]
  }
];

const DEFAULT_SYSTEM_SETTINGS: SystemSettings = {
  systemName: 'Lớp Tôi',
  systemTagline: 'Hệ Thống Quản Lý Lớp Học TNASCENT',
  supportEmail: 'truongcd.xti39@gmail.com',
  supportPhone: '096247219319',
  footerCopyright: '© 2026 Lớp Tôi. Nền tảng quản lý dạy thêm & học phí chuyên nghiệp.',
  allowPublicRegistration: true,
  sepayConfig: {
    accountNumber: '96247219319',
    bankName: 'BIDV',
    accountHolder: 'NGUYEN VAN QUAN TRI',
    apiKey: '7b18991a-7b3b-4861-bd31-7e8cc3cb0828',
    apiSecret: 'spsk_test_AQquNBTGQkXJwzTLK3E67crGYmWBttN6',
    environment: 'live'
  },
  pricingPlans: DEFAULT_PRICING_PLANS
};

const INITIAL_USERS: User[] = [
  {
    id: 'admin_master',
    name: 'Quản Trị Viên Hệ Thống (Master Admin)',
    email: 'admin@quantri.com',
    password: 'Abcd12341@',
    phone: '0909999999',
    role: 'admin',
    subject: 'Quản lý toàn bộ hệ thống dạy thêm',
    bio: 'Tài khoản Quản lý toàn bộ: Giám sát khách hàng, cấp phép giáo viên, quản trị hệ thống đa trường & lớp học.',
    avatarUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
    themePreference: 'sophisticated_dark',
    salaryCalculationType: 'per_session',
    subscriptionStatus: 'active',
    subscriptionPlan: 'unlimited',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'teacher_mai',
    name: 'Cô Hoàng Mai',
    email: 'hoangmai.toan@gmail.com',
    password: '123456',
    phone: '0901234567',
    role: 'teacher',
    subject: 'Toán Học & Luyện Thi THPT',
    centerName: 'Lớp Toán Chất Lượng Cao Cô Hoàng Mai',
    logoUrl: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=150&auto=format&fit=crop&q=80',
    address: 'Số 45 Đường Lê Duẩn, Quận Hoàn Kiếm, Hà Nội',
    bankName: 'MB Bank (Ngân Hàng Quân Đội)',
    bankAccountNumber: '090123456789',
    bankAccountName: 'HOANG THI MAI',
    invoiceFooterNotes: 'Kính chúc các em học sinh luôn nỗ lực học tập và đạt kết quả cao nhất! Quý Phụ huynh vui lòng hoàn tất học phí từ ngày 1 đến ngày 10 hàng tháng.',
    signatureImageUrl: 'https://upload.wikimedia.org/wikipedia/commons/e/e4/Signature_sample.png',
    bio: 'Giáo viên 10 năm kinh nghiệm luyện thi vào 10 và THPT Quốc Gia, chuyên ban A-A1.',
    avatarUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80',
    googleSheetUrl: 'https://docs.google.com/spreadsheets/d/1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgvE2upms/edit',
    googleSheetId: '1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgvE2upms',
    googleAppsScriptUrl: 'https://script.google.com/macros/s/AKfycbxDemoWebhookTeacherMai/exec',
    zaloWebhookUrl: 'https://openapi.zalo.me/v2.0/oa/message/cs',
    zaloPhone: '0901234567',
    themePreference: 'sophisticated_dark',
    salaryCalculationType: 'per_session',
    defaultRatePerSession: 350000,
    defaultRatePerStudent: 40000,
    defaultRevenueSharePercent: 100,
    subscriptionStatus: 'active',
    subscriptionPlan: 'pro',
    subscriptionExpiresAt: '2027-12-31',
    activatedAt: '2026-01-15',
    maxClasses: 10,
    adminNotes: 'Khách hàng mua gói Pro 1 năm bản quyền',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'teacher_tuan',
    name: 'Thầy Quốc Tuấn',
    email: 'quoctuan.ielts@gmail.com',
    password: '123456',
    phone: '0988776655',
    role: 'center_teacher',
    subject: 'Tiếng Anh & IELTS Academy',
    centerName: 'Học Viện Tiếng Anh Tuấn IELTS',
    logoUrl: 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=150&auto=format&fit=crop&q=80',
    address: 'Phòng 502, Tòa Nhà Tri Thức, 123 Cầu Giấy, Hà Nội',
    bankName: 'Techcombank (Ngân hàng Kỹ Thương)',
    bankAccountNumber: '19034567891011',
    bankAccountName: 'NGUYEN QUOC TUAN',
    invoiceFooterNotes: 'Cảm ơn Quý Phụ huynh đã tin tưởng gửi gắm con em tại Tuấn IELTS Academy. Vui lòng quét mã QR để chuyển khoản học phí.',
    bio: 'IELTS 8.5, Thạc sĩ Ngôn ngữ ứng dụng, chuyên dạy các lớp ngữ pháp và kèm 1-1.',
    avatarUrl: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&auto=format&fit=crop&q=80',
    googleSheetUrl: 'https://docs.google.com/spreadsheets/d/1DemoSheetIELTSQuocTuan2026/edit',
    googleSheetId: '1DemoSheetIELTSQuocTuan2026',
    googleAppsScriptUrl: '',
    zaloPhone: '0988776655',
    themePreference: 'midnight_sapphire',
    salaryCalculationType: 'revenue_share',
    defaultRatePerSession: 400000,
    defaultRevenueSharePercent: 75,
    subscriptionStatus: 'trial',
    subscriptionPlan: 'basic',
    subscriptionExpiresAt: '2026-09-30',
    activatedAt: '2026-08-01',
    maxClasses: 3,
    adminNotes: 'Đang dùng thử 30 ngày',
    createdAt: new Date().toISOString(),
  }
];

const INITIAL_CLASSES: ClassRoom[] = [
  {
    id: 'class_toan9_vip',
    teacherId: 'teacher_mai',
    name: 'Toán 9 - Luyện Thi Vào 10 Chuyên',
    code: 'TOAN9-CHUYEN',
    subject: 'Toán Học',
    grade: 'Lớp 9',
    classType: 'offline',
    roomOrLink: 'Phòng học 302, 45 Lê Duẩn',
    pricePerSession: 400000,
    pricePerMonth: 1200000,
    pricePerStudentPerSession: 60000,
    teacherSharePercent: 100,
    color: '#059669',
    active: true,
    notes: 'Lớp trọng điểm, tập trung Hình học phẳng và Bất đẳng thức',
    scheduleTemplate: [
      { dayOfWeek: 2, startTime: '17:30', endTime: '19:30', location: 'Phòng 302' },
      { dayOfWeek: 4, startTime: '17:30', endTime: '19:30', location: 'Phòng 302' },
      { dayOfWeek: 6, startTime: '17:30', endTime: '19:30', location: 'Phòng 302' },
    ],
    createdAt: new Date().toISOString(),
  },
  {
    id: 'class_toan12_dgnl',
    teacherId: 'teacher_mai',
    name: 'Toán 12 - Ôn Thi ĐGNL & Tốt Nghiệp',
    code: 'TOAN12-TN',
    subject: 'Toán Học',
    grade: 'Lớp 12',
    classType: 'offline',
    roomOrLink: 'Phòng 101, Nhà riêng cô Mai',
    pricePerSession: 350000,
    pricePerMonth: 1000000,
    pricePerStudentPerSession: 50000,
    teacherSharePercent: 100,
    color: '#0284c7',
    active: true,
    notes: 'Ôn theo cấu trúc đề mới 2026',
    scheduleTemplate: [
      { dayOfWeek: 3, startTime: '19:30', endTime: '21:30', location: 'Phòng 101' },
      { dayOfWeek: 5, startTime: '19:30', endTime: '21:30', location: 'Phòng 101' },
      { dayOfWeek: 0, startTime: '08:30', endTime: '11:00', location: 'Phòng 101' },
    ],
    createdAt: new Date().toISOString(),
  },
  {
    id: 'class_kem_minh',
    teacherId: 'teacher_mai',
    name: 'Kèm 1-1 em Bảo Nam (Toán 10)',
    code: 'KEM1-1-NAM',
    subject: 'Toán Học',
    grade: 'Lớp 10',
    classType: 'one_on_one',
    roomOrLink: 'Dạy tại nhà học sinh (Quận 1)',
    pricePerSession: 350000,
    pricePerMonth: 2800000,
    teacherSharePercent: 100,
    color: '#d97706',
    active: true,
    notes: 'Kèm lại nền tảng Hình học không gian',
    scheduleTemplate: [
      { dayOfWeek: 1, startTime: '18:00', endTime: '19:30', location: 'Nhà Bảo Nam' },
      { dayOfWeek: 5, startTime: '17:30', endTime: '19:00', location: 'Nhà Bảo Nam' },
    ],
    createdAt: new Date().toISOString(),
  },
  {
    id: 'class_ielts_tuan',
    teacherId: 'teacher_tuan',
    name: 'IELTS Intensive 6.5 - 7.5',
    code: 'IELTS-ADV',
    subject: 'Tiếng Anh',
    grade: 'Người lớn / Học sinh THPT',
    classType: 'online',
    roomOrLink: 'Zoom ID: 893 234 1122 (Pass: ielts2026)',
    pricePerSession: 500000,
    pricePerMonth: 2500000,
    teacherSharePercent: 75,
    color: '#6366f1',
    active: true,
    notes: 'Lớp online tập trung Writing Task 2 & Speaking Mock Test',
    scheduleTemplate: [
      { dayOfWeek: 2, startTime: '20:00', endTime: '22:00', location: 'Zoom Online' },
      { dayOfWeek: 4, startTime: '20:00', endTime: '22:00', location: 'Zoom Online' },
    ],
    createdAt: new Date().toISOString(),
  }
];

const INITIAL_STUDENTS: Student[] = [
  {
    id: 'std_1',
    teacherId: 'teacher_mai',
    classId: 'class_toan9_vip',
    name: 'Nguyễn Minh Quân',
    code: 'HS-0901',
    phone: '0912345671',
    parentName: 'Bác Hùng (Bố)',
    parentPhone: '0912345678',
    parentZalo: '0912345678',
    feeStatus: 'paid',
    tuitionFeeDue: 1200000,
    tuitionFeePaid: 1200000,
    joinedDate: '2026-07-01',
    notes: 'Học lực Khá Giỏi, tiếp thu nhanh phần Đại số',
    active: true,
  },
  {
    id: 'std_2',
    teacherId: 'teacher_mai',
    classId: 'class_toan9_vip',
    name: 'Trần Thảo Linh',
    code: 'HS-0902',
    phone: '0912345672',
    parentName: 'Cô Thu Hương (Mẹ)',
    parentPhone: '0987654321',
    parentZalo: '0987654321',
    feeStatus: 'unpaid',
    tuitionFeeDue: 1200000,
    tuitionFeePaid: 0,
    joinedDate: '2026-07-05',
    notes: 'Cần lưu ý phần góc nội tiếp đường tròn',
    active: true,
  },
  {
    id: 'std_3',
    teacherId: 'teacher_mai',
    classId: 'class_toan9_vip',
    name: 'Lê Hoàng Long',
    code: 'HS-0903',
    phone: '0912345673',
    parentName: 'Anh Tuấn (Bố)',
    parentPhone: '0933221100',
    parentZalo: '0933221100',
    feeStatus: 'paid',
    tuitionFeeDue: 1200000,
    tuitionFeePaid: 1200000,
    joinedDate: '2026-07-10',
    notes: 'Chăm chỉ, làm bài tập đầy đủ',
    active: true,
  },
  {
    id: 'std_4',
    teacherId: 'teacher_mai',
    classId: 'class_toan12_dgnl',
    name: 'Vũ Đức Duy',
    code: 'HS-1201',
    phone: '0944556677',
    parentName: 'Cô Mai Lan (Mẹ)',
    parentPhone: '0944556688',
    parentZalo: '0944556688',
    feeStatus: 'partial',
    tuitionFeeDue: 1000000,
    tuitionFeePaid: 500000,
    joinedDate: '2026-06-15',
    notes: 'Mục tiêu đỗ Bách Khoa TP.HCM',
    active: true,
  },
  {
    id: 'std_5',
    teacherId: 'teacher_mai',
    classId: 'class_kem_minh',
    name: 'Bảo Nam',
    code: 'HS-1001',
    phone: '0977112233',
    parentName: 'Chị Bích (Mẹ)',
    parentPhone: '0977112244',
    parentZalo: '0977112244',
    feeStatus: 'paid',
    tuitionFeeDue: 2800000,
    tuitionFeePaid: 2800000,
    joinedDate: '2026-08-01',
    notes: 'Học 1 kèm 1, tiến bộ rõ rệt',
    active: true,
  }
];

function generateSessionsForCurrentMonth(): ScheduleSession[] {
  const sessions: ScheduleSession[] = [];
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-11
  
  // Generate sessions for the current month based on teacher Mai classes
  const maiClasses = INITIAL_CLASSES.filter(c => c.teacherId === 'teacher_mai');

  for (let day = 1; day <= 28; day++) {
    const d = new Date(year, month, day);
    const dayOfWeek = d.getDay(); // 0=CN, 1=T2...
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const isPast = d < today;

    for (const c of maiClasses) {
      const matchSchedule = c.scheduleTemplate.find(s => s.dayOfWeek === dayOfWeek);
      if (matchSchedule) {
        const isCompleted = isPast;
        sessions.push({
          id: `sess_${c.id}_${dateStr}`,
          teacherId: 'teacher_mai',
          classId: c.id,
          className: c.name,
          classColor: c.color,
          date: dateStr,
          dayOfWeek: dayOfWeek,
          startTime: matchSchedule.startTime,
          endTime: matchSchedule.endTime,
          location: matchSchedule.location,
          status: isCompleted ? 'completed' : 'scheduled',
          topic: c.grade === 'Lớp 9' ? 'Hệ phương trình bậc nhất hai ẩn & Giải bài toán bằng cách lập hệ' : 'Hàm số bậc ba và cực trị',
          homework: 'Phiếu bài tập số 04 (Trang 12-15) nộp trước 20h buổi sau',
          notes: 'Nhắc học sinh mang máy tính bỏ túi Casio 580',
          actualStudentsPresent: c.id === 'class_kem_minh' ? 1 : 3,
          earnedAmount: c.pricePerSession,
          reminderSentZalo: isCompleted,
          createdAt: new Date().toISOString(),
        });
      }
    }
  }

  return sessions;
}

class StorageManager {
  private data: DBData;

  constructor() {
    this.data = this.load();
  }

  private load(): DBData {
    try {
      if (fs.existsSync(DB_FILE)) {
        const raw = fs.readFileSync(DB_FILE, 'utf-8');
        const parsed: DBData = JSON.parse(raw);
        if (!parsed.invoices) {
          parsed.invoices = [];
        }
        // Ensure admin_master is present
        if (!parsed.users.some(u => u.role === 'admin' || u.id === 'admin_master')) {
          parsed.users.unshift(INITIAL_USERS[0]);
        }
        // Ensure all users have password
        for (const u of parsed.users) {
          if (!u.password) {
            u.password = u.role === 'admin' || u.id === 'admin_master' ? 'Abcd12341@' : '123456';
          }
          if (u.id === 'admin_master' || u.role === 'admin') {
            u.password = 'Abcd12341@';
          }
        }
        // Ensure teachers have updated branding
        for (const t of INITIAL_USERS) {
          const idx = parsed.users.findIndex(u => u.id === t.id);
          if (idx !== -1) {
            if (!parsed.users[idx].centerName && t.centerName) {
              parsed.users[idx].centerName = t.centerName;
              parsed.users[idx].logoUrl = t.logoUrl;
              parsed.users[idx].address = t.address;
              parsed.users[idx].bankName = t.bankName;
              parsed.users[idx].bankAccountNumber = t.bankAccountNumber;
              parsed.users[idx].bankAccountName = t.bankAccountName;
              parsed.users[idx].invoiceFooterNotes = t.invoiceFooterNotes;
              parsed.users[idx].signatureImageUrl = t.signatureImageUrl;
            }
          }
        }
        // Ensure payment orders
        if (!parsed.paymentOrders) {
          parsed.paymentOrders = [];
        }
        // Ensure system settings
        if (!parsed.systemSettings || !parsed.systemSettings.sepayConfig) {
          parsed.systemSettings = { ...DEFAULT_SYSTEM_SETTINGS };
        } else {
          parsed.systemSettings.systemName = 'Lớp Tôi';
          parsed.systemSettings.footerCopyright = '© 2026 Lớp Tôi. Nền tảng quản lý dạy thêm & học phí chuyên nghiệp.';
          // Always ensure pricingPlans and sepayConfig exist
          parsed.systemSettings.pricingPlans = DEFAULT_PRICING_PLANS;
          if (!parsed.systemSettings.sepayConfig.apiKey) {
            parsed.systemSettings.sepayConfig = DEFAULT_SYSTEM_SETTINGS.sepayConfig;
          }
        }
        this.save(parsed);
        return parsed;
      }
    } catch (e) {
      console.error('Error loading DB file, fallback to defaults:', e);
    }
    const initialSessions = generateSessionsForCurrentMonth();
    const initial: DBData = {
      users: INITIAL_USERS,
      classes: INITIAL_CLASSES,
      students: INITIAL_STUDENTS,
      sessions: initialSessions,
      attendance: [],
      invoices: [],
      paymentOrders: [],
      systemSettings: { ...DEFAULT_SYSTEM_SETTINGS },
      zaloLogs: [
        {
          id: 'log_1',
          teacherId: 'teacher_mai',
          type: 'session_reminder',
          recipientName: 'Bác Hùng (PH em Quân)',
          recipientPhone: '0912345678',
          content: 'Kính gửi Bác Hùng, xin nhắc lịch học Toán 9 của em Quân vào lúc 17:30 hôm nay tại Phòng 302.',
          status: 'sent',
          sentAt: new Date().toISOString(),
        }
      ]
    };
    this.save(initial);
    return initial;
  }

  private save(dataToSave?: DBData) {
    try {
      const d = dataToSave || this.data;
      fs.writeFileSync(DB_FILE, JSON.stringify(d, null, 2), 'utf-8');
    } catch (e) {
      console.error('Error saving DB file:', e);
    }
  }

  // User auth & profile
  getUsers(): User[] {
    return this.data.users;
  }

  getTeachersOnly(): User[] {
    return this.data.users.filter(u => u.role !== 'admin');
  }

  getUserById(id: string): User | undefined {
    return this.data.users.find(u => u.id === id);
  }

  getUserByEmail(email: string): User | undefined {
    return this.data.users.find(u => u.email.toLowerCase() === email.toLowerCase());
  }

  createUser(user: User): User {
    this.data.users.push(user);
    this.save();
    return user;
  }

  updateUser(id: string, updates: Partial<User>): User | undefined {
    const idx = this.data.users.findIndex(u => u.id === id);
    if (idx === -1) return undefined;
    this.data.users[idx] = { ...this.data.users[idx], ...updates };
    this.save();
    return this.data.users[idx];
  }

  deleteUser(id: string): boolean {
    const user = this.getUserById(id);
    if (!user || user.id === 'admin_master' || user.role === 'admin') {
      return false; // NEVER delete admin account
    }
    const initialLen = this.data.users.length;
    this.data.users = this.data.users.filter(u => u.id !== id);
    // Cascade delete all teacher data
    this.data.classes = this.data.classes.filter(c => c.teacherId !== id);
    this.data.students = this.data.students.filter(s => s.teacherId !== id);
    this.data.sessions = this.data.sessions.filter(sess => sess.teacherId !== id);
    this.data.attendance = this.data.attendance.filter(att => att.teacherId !== id);
    this.data.zaloLogs = this.data.zaloLogs.filter(z => z.teacherId !== id);
    this.save();
    return this.data.users.length < initialLen;
  }

  getAdminOverviewStats() {
    const teachers = this.data.users.filter(u => u.role !== 'admin');
    const totalTeachers = teachers.length;
    const activeTeachers = teachers.filter(t => t.subscriptionStatus === 'active' || !t.subscriptionStatus).length;
    const trialTeachers = teachers.filter(t => t.subscriptionStatus === 'trial').length;
    const expiredTeachers = teachers.filter(t => t.subscriptionStatus === 'expired' || t.subscriptionStatus === 'suspended').length;
    
    const totalClasses = this.data.classes.length;
    const totalStudents = this.data.students.length;
    const totalSessionsThisMonth = this.data.sessions.length;

    let estimatedTotalTuition = 0;
    this.data.students.forEach(s => {
      estimatedTotalTuition += (s.tuitionFeePaid || 0);
    });

    const teacherDetails = teachers.map(teacher => {
      const teacherClasses = this.data.classes.filter(c => c.teacherId === teacher.id);
      const teacherStudents = this.data.students.filter(s => s.teacherId === teacher.id);
      const teacherSessions = this.data.sessions.filter(s => s.teacherId === teacher.id);
      const tuitionSum = teacherStudents.reduce((sum, s) => sum + (s.tuitionFeePaid || 0), 0);

      return {
        user: teacher,
        classCount: teacherClasses.length,
        studentCount: teacherStudents.length,
        sessionCount: teacherSessions.length,
        totalTuitionMonth: tuitionSum,
        sheetConnected: !!(teacher.googleSheetId || teacher.googleSheetUrl),
      };
    });

    return {
      totalTeachers,
      activeTeachers,
      trialTeachers,
      expiredTeachers,
      totalClasses,
      totalStudents,
      totalSessionsThisMonth,
      estimatedTotalTuition,
      teachers: teacherDetails
    };
  }

  // Classes (Tenant-isolated)
  getClasses(teacherId: string): ClassRoom[] {
    return this.data.classes.filter(c => c.teacherId === teacherId);
  }

  getClassById(teacherId: string, classId: string): ClassRoom | undefined {
    return this.data.classes.find(c => c.teacherId === teacherId && c.id === classId);
  }

  createClass(cls: ClassRoom): ClassRoom {
    this.data.classes.push(cls);
    this.save();
    return cls;
  }

  syncClassToSchedule(teacherId: string, classObj: ClassRoom): number {
    if (!classObj.scheduleTemplate || classObj.scheduleTemplate.length === 0) return 0;

    const existingSessions = this.getSessions(teacherId);
    const existingMap = new Set(existingSessions.map(s => `${s.classId}_${s.date}_${s.startTime}`));

    let createdCount = 0;
    const now = new Date();
    // Generate from start of current month to end of next month (2 full months)
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 2, 0);

    const cur = new Date(start);
    while (cur <= end) {
      const dayOfWeek = cur.getDay(); // 0 = CN, 1 = T2...
      const year = cur.getFullYear();
      const month = cur.getMonth() + 1;
      const day = cur.getDate();
      const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

      const matchTemplates = classObj.scheduleTemplate.filter(t => t.dayOfWeek === dayOfWeek);
      for (const t of matchTemplates) {
        const key = `${classObj.id}_${dateStr}_${t.startTime}`;
        if (!existingMap.has(key)) {
          const sess: ScheduleSession = {
            id: `sess_${classObj.id}_${dateStr}_${t.startTime.replace(':', '')}_${Math.random().toString(36).substring(2, 5)}`,
            teacherId,
            classId: classObj.id,
            className: classObj.name,
            classColor: classObj.color || '#059669',
            date: dateStr,
            dayOfWeek,
            startTime: t.startTime,
            endTime: t.endTime,
            location: t.location || classObj.roomOrLink || 'Phòng học',
            status: 'scheduled',
            topic: `Buổi học định kỳ môn ${classObj.subject}`,
            homework: '',
            notes: '',
            actualStudentsPresent: 0,
            earnedAmount: classObj.pricePerSession || 0,
            reminderSentZalo: false,
            createdAt: new Date().toISOString()
          };
          this.data.sessions.push(sess);
          existingMap.add(key);
          createdCount++;
        }
      }
      cur.setDate(cur.getDate() + 1);
    }

    if (createdCount > 0) {
      this.save();
    }
    return createdCount;
  }

  updateClass(teacherId: string, classId: string, updates: Partial<ClassRoom>): ClassRoom | undefined {
    const idx = this.data.classes.findIndex(c => c.teacherId === teacherId && c.id === classId);
    if (idx === -1) return undefined;
    this.data.classes[idx] = { ...this.data.classes[idx], ...updates };
    this.save();
    return this.data.classes[idx];
  }

  deleteClass(teacherId: string, classId: string): boolean {
    const initialLen = this.data.classes.length;
    this.data.classes = this.data.classes.filter(c => !(c.teacherId === teacherId && c.id === classId));
    // Also remove orphaned students and sessions
    this.data.students = this.data.students.filter(s => !(s.teacherId === teacherId && s.classId === classId));
    this.data.sessions = this.data.sessions.filter(s => !(s.teacherId === teacherId && s.classId === classId));
    this.save();
    return this.data.classes.length < initialLen;
  }

  // Students (Tenant-isolated)
  getStudents(teacherId: string, classId?: string): Student[] {
    return this.data.students.filter(s => s.teacherId === teacherId && (!classId || s.classId === classId));
  }

  createStudent(std: Student): Student {
    this.data.students.push(std);
    this.save();
    return std;
  }

  updateStudent(teacherId: string, studentId: string, updates: Partial<Student>): Student | undefined {
    const idx = this.data.students.findIndex(s => s.teacherId === teacherId && s.id === studentId);
    if (idx === -1) return undefined;
    this.data.students[idx] = { ...this.data.students[idx], ...updates };
    this.save();
    return this.data.students[idx];
  }

  deleteStudent(teacherId: string, studentId: string): boolean {
    const initialLen = this.data.students.length;
    this.data.students = this.data.students.filter(s => !(s.teacherId === teacherId && s.id === studentId));
    this.save();
    return this.data.students.length < initialLen;
  }

  // Sessions (Tenant-isolated)
  getSessions(teacherId: string, month?: string): ScheduleSession[] {
    let list = this.data.sessions.filter(s => s.teacherId === teacherId);
    if (month) {
      list = list.filter(s => s.date.startsWith(month));
    }
    return list.sort((a, b) => a.date.localeCompare(b.date) || a.startTime.localeCompare(b.startTime));
  }

  createSession(sess: ScheduleSession): ScheduleSession {
    this.data.sessions.push(sess);
    this.save();
    return sess;
  }

  updateSession(teacherId: string, sessionId: string, updates: Partial<ScheduleSession>): ScheduleSession | undefined {
    const idx = this.data.sessions.findIndex(s => s.teacherId === teacherId && s.id === sessionId);
    if (idx === -1) return undefined;
    if (updates.date) {
      updates.dayOfWeek = new Date(updates.date).getDay();
    }
    this.data.sessions[idx] = { ...this.data.sessions[idx], ...updates };
    this.save();
    return this.data.sessions[idx];
  }

  deleteSession(teacherId: string, sessionId: string): boolean {
    const initialLen = this.data.sessions.length;
    this.data.sessions = this.data.sessions.filter(s => !(s.teacherId === teacherId && s.id === sessionId));
    this.save();
    return this.data.sessions.length < initialLen;
  }

  // Attendance
  getAttendance(teacherId: string, sessionId: string): AttendanceRecord[] {
    return this.data.attendance.filter(a => a.teacherId === teacherId && a.sessionId === sessionId);
  }

  saveAttendanceBatch(teacherId: string, sessionId: string, records: AttendanceRecord[]): AttendanceRecord[] {
    // Remove old for this session
    this.data.attendance = this.data.attendance.filter(a => !(a.teacherId === teacherId && a.sessionId === sessionId));
    this.data.attendance.push(...records);
    
    // Update session student count
    const presentCount = records.filter(r => r.status === 'present').length;
    const sess = this.data.sessions.find(s => s.teacherId === teacherId && s.id === sessionId);
    if (sess) {
      sess.actualStudentsPresent = presentCount;
    }
    this.save();
    return records;
  }

  // Invoices & Receipts (Hóa đơn / Phiếu thu học phí cho giáo viên)
  getInvoices(teacherId: string, month?: string, status?: string, classId?: string, search?: string): TuitionInvoice[] {
    if (!this.data.invoices) this.data.invoices = [];
    const isMasterAdmin = teacherId === 'admin_master' || teacherId === 'all';
    let list = isMasterAdmin ? [...this.data.invoices] : this.data.invoices.filter(i => i.teacherId === teacherId);
    if (month) {
      list = list.filter(i => i.month === month);
    }
    if (status && status !== 'all') {
      list = list.filter(i => i.status === status);
    }
    if (classId && classId !== 'all') {
      list = list.filter(i => i.classId === classId);
    }
    if (search) {
      const q = search.toLowerCase();
      list = list.filter(i =>
        i.studentName.toLowerCase().includes(q) ||
        i.invoiceCode.toLowerCase().includes(q) ||
        (i.parentName && i.parentName.toLowerCase().includes(q)) ||
        (i.parentPhone && i.parentPhone.includes(q)) ||
        i.className.toLowerCase().includes(q)
      );
    }
    return list.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
  }

  getInvoiceById(teacherId: string, id: string): TuitionInvoice | undefined {
    if (!this.data.invoices) this.data.invoices = [];
    const isMasterAdmin = teacherId === 'admin_master' || teacherId === 'all';
    return this.data.invoices.find(i => (isMasterAdmin || i.teacherId === teacherId) && i.id === id);
  }

  createInvoice(invoice: TuitionInvoice): TuitionInvoice {
    if (!this.data.invoices) this.data.invoices = [];
    this.data.invoices.unshift(invoice);
    this.save();
    return invoice;
  }

  updateInvoice(teacherId: string, id: string, updates: Partial<TuitionInvoice>): TuitionInvoice | undefined {
    if (!this.data.invoices) this.data.invoices = [];
    const idx = this.data.invoices.findIndex(i => i.teacherId === teacherId && i.id === id);
    if (idx === -1) return undefined;
    this.data.invoices[idx] = { ...this.data.invoices[idx], ...updates };

    // Also synchronize back with Student record if payment is updated
    const inv = this.data.invoices[idx];
    const stdIdx = this.data.students.findIndex(s => s.teacherId === teacherId && s.id === inv.studentId);
    if (stdIdx !== -1) {
      this.data.students[stdIdx].tuitionFeePaid = inv.paidAmount;
      if (inv.paidAmount >= inv.finalAmount) {
        this.data.students[stdIdx].feeStatus = 'paid';
      } else if (inv.paidAmount > 0) {
        this.data.students[stdIdx].feeStatus = 'partial';
      } else {
        this.data.students[stdIdx].feeStatus = 'unpaid';
      }
    }

    this.save();
    return this.data.invoices[idx];
  }

  deleteInvoice(teacherId: string, id: string): boolean {
    if (!this.data.invoices) this.data.invoices = [];
    const initialLen = this.data.invoices.length;
    this.data.invoices = this.data.invoices.filter(i => !(i.teacherId === teacherId && i.id === id));
    this.save();
    return this.data.invoices.length < initialLen;
  }

  generateMonthlyInvoices(teacherId: string, month: string): TuitionInvoice[] {
    if (!this.data.invoices) this.data.invoices = [];
    const teacher = this.data.users.find(u => u.id === teacherId);
    const teacherClasses = this.data.classes.filter(c => c.teacherId === teacherId && c.active);
    const teacherStudents = this.data.students.filter(s => s.teacherId === teacherId && s.active);

    const generated: TuitionInvoice[] = [];
    const [year, m] = month.split('-');
    const mNum = parseInt(m, 10);

    for (const std of teacherStudents) {
      const cls = teacherClasses.find(c => c.id === std.classId);
      if (!cls) continue;

      // Check if invoice already exists for this student & month
      const existing = this.data.invoices.find(
        i => i.teacherId === teacherId && i.studentId === std.id && i.month === month
      );
      if (existing) continue;

      const codeSuffix = Math.floor(100 + Math.random() * 900);
      const invoiceCode = `HD-${year}${m}-${std.id.substring(0, 4).toUpperCase()}-${codeSuffix}`;
      const totalAmount = std.tuitionFeeDue || cls.pricePerMonth || 1200000;
      const paidAmount = std.tuitionFeePaid || 0;
      const finalAmount = totalAmount;

      let status: TuitionInvoice['status'] = 'pending';
      if (paidAmount >= finalAmount && finalAmount > 0) {
        status = 'paid';
      } else if (paidAmount > 0) {
        status = 'partial';
      }

      // Generate VietQR URL if bank info exists
      let qrUrl = '';
      if (teacher?.bankName && teacher?.bankAccountNumber && teacher?.bankAccountName) {
        let bankCode = 'MB';
        const bn = teacher.bankName.toUpperCase();
        if (bn.includes('VIETCOM') || bn.includes('VCB')) bankCode = 'VCB';
        else if (bn.includes('TECHCOM') || bn.includes('TCB')) bankCode = 'TCB';
        else if (bn.includes('MB')) bankCode = 'MB';
        else if (bn.includes('VPB') || bn.includes('VPBANK')) bankCode = 'VPB';
        else if (bn.includes('ACB')) bankCode = 'ACB';
        else if (bn.includes('BIDV')) bankCode = 'BIDV';
        else if (bn.includes('AGRI') || bn.includes('VBA')) bankCode = 'VBA';
        else if (bn.includes('TPB') || bn.includes('TPBANK')) bankCode = 'TPB';

        const addInfo = `HP ${std.name} ${cls.code} T${mNum}`;
        qrUrl = `https://img.vietqr.io/image/${bankCode}-${teacher.bankAccountNumber}-compact2.png?amount=${finalAmount - paidAmount}&addInfo=${encodeURIComponent(addInfo)}&accountName=${encodeURIComponent(teacher.bankAccountName)}`;
      }

      const newInv: TuitionInvoice = {
        id: `inv_${Date.now()}_${std.id}`,
        invoiceCode,
        teacherId,
        studentId: std.id,
        studentName: std.name,
        parentName: std.parentName || 'Phụ huynh',
        parentPhone: std.parentPhone || std.phone || '',
        classId: cls.id,
        className: cls.name,
        month,
        periodDescription: `Học phí tháng ${m}/${year} - Lớp ${cls.name}`,
        sessionCount: 12,
        unitPrice: cls.pricePerSession || (totalAmount / 12),
        totalAmount,
        discountAmount: 0,
        finalAmount,
        paidAmount,
        status,
        paymentMethod: paidAmount > 0 ? 'bank_transfer' : undefined,
        paidAt: paidAmount > 0 ? new Date().toISOString() : undefined,
        notes: `Phiếu thu tự động tháng ${m}/${year}. Vui lòng thanh toán trước ngày 10/${m}/${year}.`,
        dueDate: `${year}-${m}-10`,
        vietQrUrl: qrUrl,
        createdAt: new Date().toISOString()
      };

      this.data.invoices.push(newInv);
      generated.push(newInv);
    }

    this.save();
    return generated;
  }

  getInvoiceStats(teacherId: string, month?: string): InvoiceStats {
    if (!this.data.invoices) this.data.invoices = [];
    const isMasterAdmin = teacherId === 'admin_master' || teacherId === 'all';
    let list = isMasterAdmin ? [...this.data.invoices] : this.data.invoices.filter(i => i.teacherId === teacherId);
    if (month) {
      list = list.filter(i => i.month === month);
    }

    const totalInvoices = list.length;
    let totalExpectedRevenue = 0;
    let totalCollectedRevenue = 0;
    let totalPendingRevenue = 0;
    let paidCount = 0;
    let pendingCount = 0;
    let partialCount = 0;

    for (const inv of list) {
      const finalAmt = inv.finalAmount ?? inv.totalAmount ?? 0;
      const paidAmt = inv.paidAmount ?? 0;
      totalExpectedRevenue += finalAmt;
      totalCollectedRevenue += paidAmt;
      totalPendingRevenue += Math.max(0, finalAmt - paidAmt);

      if (inv.status === 'paid' || paidAmt >= finalAmt) {
        paidCount++;
      } else if (inv.status === 'partial' || paidAmt > 0) {
        partialCount++;
      } else {
        pendingCount++;
      }
    }

    return {
      totalInvoices,
      totalExpectedRevenue,
      totalCollectedRevenue,
      totalPendingRevenue,
      paidCount,
      pendingCount,
      partialCount
    };
  }

  // Zalo logs
  getZaloLogs(teacherId: string): ZaloNotificationLog[] {
    return this.data.zaloLogs.filter(l => l.teacherId === teacherId).slice(-50);
  }

  addZaloLog(log: ZaloNotificationLog): ZaloNotificationLog {
    this.data.zaloLogs.unshift(log);
    this.save();
    return log;
  }

  // System Settings Branding
  getSystemSettings(): SystemSettings {
    if (!this.data.systemSettings) {
      this.data.systemSettings = { ...DEFAULT_SYSTEM_SETTINGS };
      this.save();
    }
    return this.data.systemSettings;
  }

  updateSystemSettings(updates: Partial<SystemSettings>): SystemSettings {
    const current = this.getSystemSettings();
    this.data.systemSettings = {
      ...current,
      ...updates,
      sepayConfig: {
        ...current.sepayConfig,
        ...(updates.sepayConfig || {})
      },
      pricingPlans: updates.pricingPlans || current.pricingPlans
    };
    this.save();
    return this.data.systemSettings;
  }

  // Payment Orders (SePay & Registration)
  getPaymentOrders(): PaymentOrder[] {
    return this.data.paymentOrders || [];
  }

  getPaymentOrder(id: string): PaymentOrder | undefined {
    return (this.data.paymentOrders || []).find(o => o.id === id);
  }

  getPaymentOrderByCode(orderCode: string): PaymentOrder | undefined {
    return (this.data.paymentOrders || []).find(
      o => o.orderCode.toUpperCase() === orderCode.toUpperCase()
    );
  }

  createPaymentOrder(data: Partial<PaymentOrder>): PaymentOrder {
    if (!this.data.paymentOrders) this.data.paymentOrders = [];
    const id = `order_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`;
    const orderCode = data.orderCode || `TM${Date.now().toString().slice(-6)}`;
    const newOrder: PaymentOrder = {
      id,
      orderCode,
      teacherName: data.teacherName || '',
      teacherEmail: data.teacherEmail || '',
      teacherPassword: data.teacherPassword || '123456',
      teacherPhone: data.teacherPhone || '',
      teacherSubject: data.teacherSubject || 'Toán - Anh - Lý',
      planId: data.planId || 'plan_1m',
      planName: data.planName || 'Gói 1 Tháng',
      durationMonths: data.durationMonths || 1,
      amount: data.amount || 38000,
      status: 'pending',
      qrUrl: data.qrUrl || '',
      createdAt: new Date().toISOString()
    };
    this.data.paymentOrders.unshift(newOrder);
    this.save();
    return newOrder;
  }

  updatePaymentOrder(orderId: string, updates: Partial<PaymentOrder>): PaymentOrder | undefined {
    if (!this.data.paymentOrders) this.data.paymentOrders = [];
    const idx = this.data.paymentOrders.findIndex(o => o.id === orderId);
    if (idx === -1) return undefined;
    this.data.paymentOrders[idx] = { ...this.data.paymentOrders[idx], ...updates };
    this.save();
    return this.data.paymentOrders[idx];
  }

  activatePaymentOrder(orderId: string, transactionId?: string): { success: boolean; user?: User; order?: PaymentOrder } {
    const order = this.getPaymentOrder(orderId);
    if (!order) return { success: false };

    // Calculate expiry date
    const now = new Date();
    const expiry = new Date();
    expiry.setMonth(now.getMonth() + (order.durationMonths || 1));

    // Check if user already exists
    let user = this.getUserByEmail(order.teacherEmail);
    if (user) {
      // Extend existing subscription
      const currentExpiry = user.subscriptionExpiresAt ? new Date(user.subscriptionExpiresAt) : new Date();
      const baseDate = currentExpiry > new Date() ? currentExpiry : new Date();
      baseDate.setMonth(baseDate.getMonth() + (order.durationMonths || 1));

      user = this.updateUser(user.id, {
        subscriptionStatus: 'active',
        subscriptionPlan: order.planName,
        subscriptionExpiresAt: baseDate.toISOString()
      });
    } else {
      // Create new teacher user
      const newUserId = `teacher_${Date.now()}`;
      user = {
        id: newUserId,
        name: order.teacherName,
        email: order.teacherEmail,
        password: order.teacherPassword || '123456',
        phone: order.teacherPhone || '',
        role: 'teacher',
        subject: order.teacherSubject || 'Giáo viên dạy thêm',
        subscriptionStatus: 'active',
        subscriptionPlan: order.planName,
        subscriptionExpiresAt: expiry.toISOString(),
        salaryCalculationType: 'per_session',
        themePreference: 'emerald_light',
        createdAt: new Date().toISOString()
      };
      this.createUser(user);
    }

    // Update order status
    this.updatePaymentOrder(orderId, {
      status: 'paid',
      sepayTransactionId: transactionId || `TXN_${Date.now()}`,
      paidAt: new Date().toISOString()
    });

    return {
      success: true,
      user,
      order: this.getPaymentOrder(orderId)
    };
  }

  // Reschedule a session
  rescheduleSession(
    teacherId: string,
    sessionId: string,
    newDate: string,
    newTime: string,
    reason: string
  ): ScheduleSession | undefined {
    const session = this.getSessions(teacherId).find(s => s.id === sessionId);
    if (!session) return undefined;

    const originalDate = session.originalDate || session.date;
    const originalTime = session.originalTime || `${session.startTime} - ${session.endTime}`;

    const [startH, endH] = newTime.includes('-')
      ? newTime.split('-').map(t => t.trim())
      : [session.startTime, session.endTime];

    return this.updateSession(teacherId, sessionId, {
      date: newDate,
      startTime: startH,
      endTime: endH,
      status: 'rescheduled',
      originalDate,
      originalTime,
      rescheduleReason: reason,
      notes: reason ? `[Đã dời ca]: ${reason}` : session.notes
    });
  }
}

export const db = new StorageManager();
